<script setup lang="ts">
/** TMP090 — Increase of Paid-Up Capital (OTC) (DCR). 실제 변수: company, constitution_clause_number,
 *  paid_up_capital_before/after, total_new_shares, share_price, allottee loop, dcr_date, Signers.
 *  토글: OtcDcrIntro(is_sole/multiple_director_company + resolution_basis) + has_constitution. */
import { computed, inject } from 'vue';
import { OTC_DOC_CTX } from './otcContext';
import OtcDocVarField from './OtcDocVarField.vue';
import OtcDocHead from './parts/OtcDocHead.vue';
import OtcDcrIntro from './parts/OtcDcrIntro.vue';
import OtcAllotteeTable from './parts/OtcAllotteeTable.vue';
import OtcSigners from './parts/OtcSigners.vue';

const ctx = inject(OTC_DOC_CTX)!;
const hasConstitution = computed(() => ctx.flag('has_constitution'));
</script>

<template>
  <div class="allot-doc">
    <OtcDocHead />
    <OtcDcrIntro />

    <p class="doc-sec-title">INCREASE PAID-UP SHARE CAPITAL</p>
    <p class="doc-p">
      THAT the issue and paid-up share capital of the Company be increased from
      RM<OtcDocVarField field-key="paid_up_capital_before" /> to
      RM<OtcDocVarField field-key="paid_up_capital_after" /> by way of a new issue of
      <OtcDocVarField field-key="total_new_shares" /> ordinary shares of
      RM<OtcDocVarField field-key="share_price" /> each for non-cash and that such new shares under the
      above mentioned issue shall rank pari passu in all respects with the existing ordinary shares of the Company.
    </p>

    <p class="doc-lbl-title">Non-Cash Allotment</p>
    <OtcAllotteeTable />

    <p class="doc-p" style="margin-top:12px">
      THAT authority be and is hereby given to the Directors to issue and affix the common seal of the Company onto the new share
      certificate(s) in accordance with the Company's
      <span class="doc-toggle" title="Constitution / Articles of Association" @click="ctx.toggleFlag('has_constitution')">{{ hasConstitution ? 'Constitution' : 'Articles of Association' }}</span>.
    </p>

    <OtcSigners var-key="increase" board-label="BOARD OF DIRECTORS" />
    <p class="doc-p" style="margin-top:14px"><b>Date:</b> <OtcDocVarField field-key="dcr_date" /></p>
  </div>
</template>
